(() => {
  const directory = document.querySelector('[data-review-directory]');
  if (!directory) return;

  const form = directory.querySelector('[data-review-search]');
  const input = directory.querySelector('[data-review-query]');
  const results = directory.querySelector('[data-review-results]');
  const status = directory.querySelector('[data-review-status]');
  const grid = directory.querySelector('[data-review-grid]');
  const pagination = directory.querySelector('.darabara-review-directory__pagination');
  const count = directory.querySelector('.darabara-review-directory__count');
  let indexPromise;
  let matched = [];
  let shown = 0;
  let searchNumber = 0;

  const normalize = (value) => value.normalize('NFKD').toLocaleLowerCase().trim();

  async function loadIndex() {
    const entries = [];
    const visited = new Set();
    let next = new URL(directory.dataset.indexUrl, location.href);
    while (next) {
      if (visited.has(next.href)) throw new Error('Review index pagination did not advance');
      visited.add(next.href);
      const response = await fetch(next.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Review index HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const list = doc.querySelector('[data-review-index]');
      if (!list) throw new Error('Review index template is unavailable');
      for (const link of list.querySelectorAll('a[data-title]')) {
        const url = new URL(link.getAttribute('href'), next);
        if (url.origin !== location.origin) continue;
        entries.push({
          title: link.dataset.title || link.textContent.trim(),
          handle: link.dataset.handle || '',
          count: Number(link.dataset.count) || 0,
          url: url.href,
        });
      }
      const nextLink = list.querySelector('a[rel="next"]');
      next = nextLink ? new URL(nextLink.getAttribute('href'), next) : null;
      if (next) next.searchParams.set('view', 'review-search-index');
    }
    return entries;
  }

  function appendResults() {
    const fragment = document.createDocumentFragment();
    const end = Math.min(shown + 30, matched.length);
    for (let i = shown; i < end; i += 1) {
      const item = matched[i];
      const link = document.createElement('a');
      link.href = item.url;
      const name = document.createElement('span');
      name.textContent = item.title;
      const total = document.createElement('small');
      total.textContent = `${item.count} ${item.count === 1 ? 'review' : 'reviews'}`;
      link.append(name, total);
      fragment.append(link);
    }
    shown = end;
    const more = results.querySelector('button');
    if (more) more.remove();
    results.append(fragment);
    if (shown < matched.length) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = `Show more (${matched.length - shown} remaining)`;
      button.addEventListener('click', appendResults);
      results.append(button);
    }
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const currentSearch = ++searchNumber;
    const query = normalize(input.value);
    if (!query) {
      results.hidden = true;
      status.hidden = true;
      if (grid) grid.hidden = false;
      if (pagination) pagination.hidden = false;
      if (count) count.hidden = false;
      return;
    }
    status.hidden = false;
    status.textContent = 'Searching all reviewed products…';
    results.hidden = true;
    try {
      indexPromise ||= loadIndex().catch((error) => {
        indexPromise = undefined;
        throw error;
      });
      const index = await indexPromise;
      if (currentSearch !== searchNumber) return;
      matched = index.filter((item) => normalize(`${item.title} ${item.handle}`).includes(query));
      matched.sort((a, b) => {
        const aStarts = normalize(a.title).startsWith(query);
        const bStarts = normalize(b.title).startsWith(query);
        return Number(bStarts) - Number(aStarts) || a.title.localeCompare(b.title);
      });
      shown = 0;
      results.replaceChildren();
      if (grid) grid.hidden = true;
      if (pagination) pagination.hidden = true;
      if (count) count.hidden = true;
      status.textContent = matched.length ? `${matched.length} reviewed ${matched.length === 1 ? 'product' : 'products'} found` : 'No reviewed products match that name.';
      if (matched.length) {
        results.hidden = false;
        appendResults();
      }
    } catch (error) {
      if (currentSearch !== searchNumber) return;
      status.textContent = 'Product review search is temporarily unavailable. Please try again later.';
      console.warn('DARABARA review search unavailable:', error);
    }
  });
})();